/* eslint-disable no-param-reassign */
import { createAction } from 'redux-actions';

import { upperSnakeCase, camelCase } from './string';

/**
 * Change to upper snake case
 */
function normalize(...names) {
  return names.map(upperSnakeCase);
}

/**
 * return all variants of actions for resources
 */
function loadAll(...resourceNames) {
  return [].concat(...resourceNames.map(resource => ([
    `get ${resource}`,
    `loading ${resource}`,
    `loaded ${resource}`,
  ])));
}

/**
 * getActionTypes
 */
function getActionTypes(actionNames) {
  return actionNames.reduce((actionTypes, actionName) => {
    actionTypes[actionName] = actionName;
    return actionTypes;
  }, {});
}

/**
 * getActions
 */
function getActions(actionNames) {
  return actionNames.reduce((actions, actionName) => {
    const actionCreatorName = camelCase(actionName);
    actions[actionCreatorName] = createAction(
      actionName,
      x => x,
      (x, y) => y,
    );
    return actions;
  }, {});
}

/**
 * createActions
 *
 * returns action creaters for action names passed. For resource
 * action names, action creators corresponding to get-resource,
 * loading-resource, and loaded-resource will be returned.
 *
 * @param {Array} resources list of resources
 * @param {Array} otherActions list of other actions
 */
export default function createActions(resources, otherActions) {
  const actionNames = normalize(...loadAll(...resources), ...otherActions);

  return {
    actionTypes: getActionTypes(actionNames),
    actions: getActions(actionNames),
  };
}
